import { z } from 'zod';

export const companyBranchBlockUnblockSchema = z.object({
  reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type CompanyBranchBlockUnblockValidationSchema = z.infer<typeof companyBranchBlockUnblockSchema>;
